import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { gsap } from 'gsap';
//import { useHistory } from 'react-router-dom';
//import VerticalSlider from '../components/VerticalSlider';
/*const Slider = React.lazy(() => import('./Slider'));
 */

import AnimacionVasoKaliman from '../functions/AnimacionVasoKaliman';
import bannerProduct from '../assets/inicio/banner/Banner-Etiquetas.webp';
import bannerProductMobile from '../assets/inicio/banner/mobile/Banner-Etiquetas-MB.gif';
import AnimacionVasoLogo from '../functions/AnimacionVasoLogo';

// Importar imágenes para el nuevo banner animado
import circuloBanner from '../assets/inicio/banner/circulo.png';
import metalizada from '../assets/inicio/banner/01-metalizada.png';
import glowinthedark from '../assets/inicio/banner/01-glowinthedark.png';
import holografico from '../assets/inicio/banner/01-holografico.png';
import stickers from '../assets/inicio/banner/01-stickers.png';
import mangas01 from '../assets/inicio/banner/02-mangasTermoencogibles01.png';
import mangas02 from '../assets/inicio/banner/02-mangasTermoencogibles02.png';
import mangas03 from '../assets/inicio/banner/02-mangasTermoencogibles03.png';
import farmaceutico from '../assets/inicio/banner/03-farmaceutico.png';
import coldfoil02 from '../assets/inicio/banner/04-coldfoil02.png';
import coldfoil03 from '../assets/inicio/banner/04-coldfoil03.png';
import coldfoil04 from '../assets/inicio/banner/04-coldfoil04.png';
import coldfoil05 from '../assets/inicio/banner/04-coldfoil05.png';
import booklet from '../assets/inicio/banner/05-booklet.png';
import scratch from '../assets/inicio/banner/05-scratch.png';
import seguridad from '../assets/inicio/banner/05-seguridad.png';




// Importar iconos
import iconoAlimentos from '../assets/inicio/iconos/botella-de-agua-Blanco 1.png';
import iconoFarmaceutica from '../assets/inicio/iconos/frasco-con-cruz-Blanco 1.png';
import iconoCosmetica from '../assets/inicio/iconos/frasco-cosm-tico-Blanco 1.png';
import iconoVinos from '../assets/inicio/iconos/botella-de-vino-con-Blanco 1.png';
import iconoAnimal from '../assets/inicio/iconos/silueta-de-mascota---frasco-Blanco 1.png';
import iconoManufacturera from '../assets/inicio/iconos/engrane-Blanco 2.png';
import iconoEventosMasivos from '../assets/inicio/iconos/Estadio-Rojo.png';

// Importar imágenes de banner
import banner1 from '../assets/inicio/banner/bannersHome01.webp';
// import banner11 from '../assets/inicio/banner/bannersHome1.5.webp';
import banner2 from '../assets/inicio/banner/bannersHome02.webp';
import banner3 from '../assets/inicio/banner/bannersHome03.webp';
import banner4 from '../assets/inicio/banner/bannersHome04.webp';
import banner5 from '../assets/inicio/banner/bannersHome05.webp';

// Importar imágenes de banner mobile
import bannerMobile1 from '../assets/inicio/banner/mobile/bannersHome01.png';
// import bannerMobile11 from '../assets/inicio/banner/mobile/bannersHome1.5.png';
import bannerMobile2 from '../assets/inicio/banner/mobile/bannersHome02.png';
import bannerMobile3 from '../assets/inicio/banner/mobile/bannersHome03.png';
import bannerMobile4 from '../assets/inicio/banner/mobile/bannersHome04.png';
import bannerMobile5 from '../assets/inicio/banner/mobile/bannersHome05.png';

import transformamosEtiquetas from '../assets/inicio/transformamos-etiquetas.webp';
// import vasosRight from '../assets/inicio/inicioVaso01.webp';
// import vasosLeft from '../assets/inicio/inicioVaso02.webp';
import vasosFinal from '../assets/inicio/inicioFinal.webp';
import experiencia from '../assets/inicio/inicioImage02.png';
// import video from '../assets/inicio/video.png';
import videoEtiqueta from '../assets/inicio/inicioEtiquetaVideo.png';

//Imagen del banner de productos
// import productImage from '../assets/inicio/banner/product.png';

//Imagenes del quinto slider
import logoAlpura from '../assets/inicio/logos/alpura.png';
import logoChobani from '../assets/inicio/logos/chobani.png';
import logoChupachups from '../assets/inicio/logos/chupachups.png';
import logoDove from '../assets/inicio/logos/dove.png';
import logoGourmet from '../assets/inicio/logos/gourmet.png';
import logoKrispykreme from '../assets/inicio/logos/krispykreme.png';
import logoRancho from '../assets/inicio/logos/rancho.png';
import logoTrujillo from '../assets/inicio/logos/trujillo.png';
//import logoPeñaranda from '../assets/inicio/logos/logoPeñaranda.png';

// Componente de Banner Animado (recibe referencia del fondo del slide)
const AnimatedBanner = ({ sliderBackgroundRef }) => {
  const transition1Ref = useRef([]);
  const transition2Ref = useRef([]);
  const transition3Ref = useRef(null);
  const transition4Ref = useRef([]);
  const transition5Ref = useRef([]);

  useEffect(() => {
    if (!sliderBackgroundRef.current) return;

    const timeline = gsap.timeline({ repeat: -1 });

    // Transición 1: Fondo degradado blanco a crema
    timeline
      .to(sliderBackgroundRef.current, {
        background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.7) 0%, rgba(245, 245, 220, 0.7) 100%)',
        duration: 0.5,
        ease: 'power2.inOut'
      })
      // Aparición de las imágenes de la transición 1 (desde abajo con fade in)
      .fromTo(
        transition1Ref.current,
        {
          y: 100,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '-=0.3'
      )
      // Mantener por 0.5 segundos
      .to({}, { duration: 0.5 })
      // Desaparición con parábola hacia la derecha y abajo con rotación
      .to(
        transition1Ref.current,
        {
          x: 300,
          y: 100,
          rotation: 25,
          opacity: 0,
          duration: 0.5,
          stagger: 0.1,
          ease: 'power2.in'
        }
      )
      // Transición 2: Fondo degradado blanco a gris
      .to(
        sliderBackgroundRef.current,
        {
          background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.7) 0%, rgba(211, 211, 211, 0.7) 100%)',
          duration: 0.5,
          ease: 'power2.inOut'
        },
        '-=0.3'
      )
      // Resetear posición de transición 1 para el loop
      .set(transition1Ref.current, { x: 0, y: 0, rotation: 0, opacity: 0 })
      // Aparición de las imágenes de la transición 2
      .fromTo(
        transition2Ref.current,
        {
          y: 100,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '-=0.3'
      )
      // Mantener por 0.5 segundos
      .to({}, { duration: 0.5 })
      // Desaparición con parábola hacia la derecha y abajo con rotación
      .to(
        transition2Ref.current,
        {
          x: 300,
          y: 100,
          rotation: 25,
          opacity: 0,
          duration: 0.5,
          stagger: 0.1,
          ease: 'power2.in'
        }
      )
      // Resetear posición de transición 2 para el loop
      .set(transition2Ref.current, { x: 0, y: 0, rotation: 0, opacity: 0 })
      // Transición 3: Fondo degradado blanco a naranja
      .to(
        sliderBackgroundRef.current,
        {
          background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 165, 0, 0.7) 100%)',
          duration: 0.5,
          ease: 'power2.inOut'
        },
        '-=0.3'
      )
      // Aparición de la imagen de la transición 3 (desde abajo con fade in)
      .fromTo(
        transition3Ref.current,
        {
          y: 100,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          ease: 'power2.out'
        },
        '-=0.3'
      )
      // Mantener por 0.5 segundos
      .to({}, { duration: 0.5 })
      // Desaparición con parábola hacia la derecha y abajo con rotación
      .to(
        transition3Ref.current,
        {
          x: 300,
          y: 100,
          rotation: 25,
          opacity: 0,
          duration: 0.5,
          ease: 'power2.in'
        }
      )
      // Resetear posición de transición 3 para el loop
      .set(transition3Ref.current, { x: 0, y: 0, rotation: 0, opacity: 0 })
      // Transición 4: Fondo degradado café claro a café oscuro
      .to(
        sliderBackgroundRef.current,
        {
          background: 'linear-gradient(90deg, rgba(210, 180, 140, 0.7) 0%, rgba(101, 67, 33, 0.7) 100%)',
          duration: 0.5,
          ease: 'power2.inOut'
        },
        '-=0.3'
      )
      // Aparición de las imágenes de la transición 4 (desde abajo con fade in)
      .fromTo(
        transition4Ref.current,
        {
          y: 100,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '-=0.3'
      )
      // Mantener por 0.5 segundos
      .to({}, { duration: 0.5 })
      // Desaparición con parábola hacia la derecha y abajo con rotación
      .to(
        transition4Ref.current,
        {
          x: 300,
          y: 100,
          rotation: 25,
          opacity: 0,
          duration: 0.5,
          stagger: 0.1,
          ease: 'power2.in'
        }
      )
      // Resetear posición de transición 4 para el loop
      .set(transition4Ref.current, { x: 0, y: 0, rotation: 0, opacity: 0 })
      // Transición 5: Fondo degradado azul claro a azul turquesa
      .to(
        sliderBackgroundRef.current,
        {
          background: 'linear-gradient(90deg, rgba(173, 216, 230, 0.7) 0%, rgba(64, 224, 208, 0.7) 100%)',
          duration: 0.5,
          ease: 'power2.inOut'
        },
        '-=0.3'
      )
      // Aparición de las imágenes de la transición 5 (desde abajo con fade in)
      .fromTo(
        transition5Ref.current,
        {
          y: 100,
          opacity: 0
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          stagger: 0.1,
          ease: 'power2.out'
        },
        '-=0.3'
      )
      // Mantener por 0.5 segundos
      .to({}, { duration: 0.5 })
      // Desaparición con parábola hacia la derecha y abajo con rotación
      .to(
        transition5Ref.current,
        {
          x: 300,
          y: 100,
          rotation: 25,
          opacity: 0,
          duration: 0.5,
          stagger: 0.1,
          ease: 'power2.in'
        }
      )
      // Resetear posición de transición 5 para el loop
      .set(transition5Ref.current, { x: 0, y: 0, rotation: 0, opacity: 0 });

    return () => {
      timeline.kill();
    };
  }, [sliderBackgroundRef]);

  return (
    <div
      style={{
        position: 'relative',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'visible'
      }}
    >
      {/* Transición 1 - Imágenes */}
      <div style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'row',
        gap: '0px',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        width: '100%'
      }}>
        <img
          ref={el => transition1Ref.current[0] = el}
          src={metalizada}
          alt="Metalizada"
          style={{ zIndex: 50, height: '300px', width: 'auto', objectFit: 'contain', display: 'block', marginLeft: '0px', marginTop: '100px' }}
        />
        <img
          ref={el => transition1Ref.current[1] = el}
          src={glowinthedark}
          alt="Glow in the dark"
          style={{ height: '300px', width: 'auto', objectFit: 'contain', display: 'block', marginLeft: '-160px', marginTop: '-100px' }}
        />
        <img
          ref={el => transition1Ref.current[2] = el}
          src={holografico}
          alt="Holográfico"
          style={{ height: '300px', width: 'auto', objectFit: 'contain', display: 'block', marginLeft: '-80px', marginTop: '-100px' }}
        />
        <img
          ref={el => transition1Ref.current[3] = el}
          src={stickers}
          alt="Stickers"
          style={{ height: '300px', width: 'auto', objectFit: 'contain', display: 'block', marginLeft: '-360px', marginTop: '100px' }}
        />
      </div>

      {/* Transición 2 - Imágenes */}
      <div style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'row',
        gap: '0px',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        width: '100%'
      }}>
        <img
          ref={el => transition2Ref.current[0] = el}
          src={mangas01}
          alt="Mangas Termoencogibles 01"
          style={{ zIndex: 5, height: '340px', width: 'auto', objectFit: 'contain', opacity: 0, display: 'block' }}
        />
        <img
          ref={el => transition2Ref.current[1] = el}
          src={mangas02}
          alt="Mangas Termoencogibles 02"
          style={{ height: '340px', width: 'auto', objectFit: 'contain', opacity: 0, display: 'block', marginLeft: '-40px', marginTop: '-20px' }}
        />
        <img
          ref={el => transition2Ref.current[2] = el}
          src={mangas03}
          alt="Mangas Termoencogibles 03"
          style={{ height: '340px', width: 'auto', objectFit: 'contain', opacity: 0, display: 'block', marginLeft: '-40px' }}
        />
      </div>

      {/* Transición 3 - Imagen única */}
      <div style={{
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%'
      }}>
        <img
          ref={transition3Ref}
          src={farmaceutico}
          alt="Farmacéutico"
          style={{ height: '500px', width: 'auto', objectFit: 'contain', opacity: 0, display: 'block' }}
        />
      </div>

      {/* Transición 4 - Imágenes coldfoil */}
      <div style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'row',
        gap: '0px',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        width: '100%'
      }}>
        <img
          ref={el => transition4Ref.current[0] = el}
          src={coldfoil02}
          alt="Cold Foil 02"
          style={{ height: '300px', width: 'auto', objectFit: 'contain', opacity: 0, display: 'block' }}
        />
        <img
          ref={el => transition4Ref.current[1] = el}
          src={coldfoil03}
          alt="Cold Foil 03"
          style={{ height: '300px', width: 'auto', objectFit: 'contain', opacity: 0, display: 'block', marginLeft: '-30px' }}
        />
        <img
          ref={el => transition4Ref.current[2] = el}
          src={coldfoil04}
          alt="Cold Foil 04"
          style={{ height: '300px', width: 'auto', objectFit: 'contain', opacity: 0, display: 'block', marginLeft: '-30px' }}
        />
        <img
          ref={el => transition4Ref.current[3] = el}
          src={coldfoil05}
          alt="Cold Foil 05"
          style={{ height: '300px', width: 'auto', objectFit: 'contain', opacity: 0, display: 'block', marginLeft: '-30px' }}
        />
      </div>

      {/* Transición 5 - Imágenes booklet, scratch, seguridad */}
      <div style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'row',
        gap: '0px',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        width: '100%'
      }}>
        <img
          ref={el => transition5Ref.current[0] = el}
          src={booklet}
          alt="Booklet"
          style={{ height: '300px', width: 'auto', objectFit: 'contain', opacity: 0, display: 'block' }}
        />
        <img
          ref={el => transition5Ref.current[2] = el}
          src={scratch}
          alt="Scratch"
          style={{  height: '300px', width: 'auto', objectFit: 'contain', opacity: 0, display: 'block', marginLeft: '-100px', marginTop: '200px'}}
        />
        <img
          ref={el => transition5Ref.current[1] = el}
          src={seguridad}
          alt="Seguridad"
          style={{ zIndex:-1,height: '300px', width: 'auto', objectFit: 'contain', opacity: 0, display: 'block', marginLeft: '-200px' }}
        />
      </div>
    </div>
  );
};

// Componente del Slider Animado completo
const AnimatedSlider = ({ interval }) => {
  const sliderBackgroundRef = useRef(null);

  return (
    <div className="carousel-item active slider-two" data-bs-interval={interval}>
      {/* Fondo del círculo - capa estática */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${circuloBanner})`,
          backgroundPosition: 'center center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          zIndex: 1
        }}
        className="d-block w-100"
      />

      {/* Fondo del slider que cambia de color - capa animada */}
      <div
        ref={sliderBackgroundRef}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.7) 0%, rgba(245, 245, 220, 0.7) 100%)',
          zIndex: 0
        }}
        className="d-block w-100"
      />

      <div className="carousel-caption d-flex flex-column justify-content-center ps-5 ps-md-5 ps-3" style={{ position: 'relative', width: '100%', height: '100%', zIndex: 2, top: 0, left: 0, right: 0, transform: 'none' }}>
        <div className='container-fluid' style={{ height: '100%' }}>
          <div className='row align-items-center align-items-md-center align-items-start' style={{ height: '100%' }}>
            {/* Columna de texto (arriba en mobile, izquierda en desktop) */}
            <div className='col-lg-5 col-md-4 col-12 d-flex flex-column justify-content-center order-0 pt-4 pt-md-0' style={{ zIndex: 2 }}>
              <h1 className="display-4 lightblack mb-3 text-start tit-principal tit-slider">
                <span style={{ color: 'var(--color-principal)' }}>Etiquetas para cualquier</span> tipo de industria
              </h1>
              <div className="d-flex gap-3 justify-content-start">
                <a href="/productos" className="btn btn-custom mt-2 mb-sm-0 p-3">
                  Nuestros productos
                </a>
              </div>
            </div>

            {/* Columna de animaciones (abajo en mobile, derecha en desktop) */}
            <div className='col-md-7 col-12 order-1 pb-md-0 pb-3' style={{ position: 'relative', zIndex: 1, height: '100%' }}>
              <AnimatedBanner sliderBackgroundRef={sliderBackgroundRef} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Inicio = () => {
  //Contenido en los sliders
  const slides = [
    {
      id: 1,
      title: "Más de dos décadas",
      subtitle: "colaborando con",
      highlight: "marcas",
      highlight2: "que exigen resultados",
      highlight3: "",
      description: "Más de 28 años acompañando a empresas de distintos sectores a sobresalir. Desarrollamos etiquetas y soluciones a tu medida siempre con un extra.",
      backgroundImage: `url(${ bannerProduct})`,
      backgroundImageMobile: `url(${bannerProductMobile})`
    },
    {
      id: 2,
      title: "Etiquetas que",
      subtitle: "hacer mucho más",
      highlight: "",
      highlight2: "",
      highlight3: "",
      description: "",
      backgroundImage: `url(${banner1})`,
      backgroundImageMobile: `url(${bannerMobile1})`
    },
    {
      id: 3,
      title: "Más de dos décadas",
      subtitle: "colaborando con",
      highlight: "marcas",
      highlight2: "que exigen resultados",
      highlight3: "",
      description: "Más de 28 años acompañando a empresas de distintos sectores a sobresalir. Desarrollamos etiquetas y soluciones a tu medida siempre con un extra.",
      backgroundImage: `url(${banner2})`,
      backgroundImageMobile: `url(${bannerMobile2})`
    },
    {
      id: 4,
      title: "Nuestras",
      subtitle: "soluciones",
      highlight: "potencializan el",
      highlight2: "éxito de tu",
      highlight3: "producto",
      description: "",
      backgroundImage: `url(${banner3})`,
      backgroundImageMobile: `url(${bannerMobile3})`
    },
    {
      id: 5,
      title: "ISO 22000:",
      subtitle: "Calidad y seguridad que",
      highlight: "respalda cada etiqueta",
      highlight2: "en tus alimentos",
      highlight3: "",
      description: "Solo procesos seguros, consistentes y auditables en cada etiqueta",
      backgroundImage: `url(${banner4})`,
      backgroundImageMobile: `url(${bannerMobile4})`
    },
    {
      id: 6,
      title: "Marcas con las",
      subtitle: "que crecemos",
      highlight: "juntos",
      highlight2: "",
      highlight3: "",
      description: "",
      backgroundImage: `url(${banner5})`,
      backgroundImageMobile: `url(${bannerMobile5})`
    }
  ];

  //Cambio de background desktop a mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 575);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 575);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //Cambio de background desktop a mobile excepción del banner 1
  // COMENTADO - No se usa con el nuevo banner animado
  // const [isMobileBanner, setIsMobileBanner] = useState(window.innerWidth <= 575);
  // useEffect(() => {
  //   const handleResize = () => setIsMobileBanner(window.innerWidth <= 575);
  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, []);

  //Animación Slider
  // const [currentSlide, setCurrentSlide] = useState(0);
  const nextSlide = () => {
    // setCurrentSlide((prev) => (prev + 1) % slides.length);
  };
  const prevSlide = () => {
    // setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };
  //// Auto-play cada 5 segundos
  /////useEffect(() => {
    ////const interval = setInterval(() => {
      ////nextSlide();
    /////}, 5000);
    /////return () => clearInterval(interval);
  /////}, []);*/

  //Dirección para btn Sumamos valor
    const history = useNavigate();

    // COMENTADO - No se usa con el nuevo banner animado
    // const images = [
    //   bannerProduct,
    //   bannerProductMobile,
    // ];
    // images.forEach(src => {
    //   const img = new Image();
    //   img.src = src;
    // });

  ///Temporizador para banner de productos - Slide animado
  //Este slide tiene un intervalo de 11 segundos para mostrar las 5 transiciones completas (~10.5s)
  const [interval] = useState(11000); // 11 segundos para la animación completa

  return (
    <div className="main-content">
      <div className="container-fluid p-0">
        <div className="page-container pt-0 pb-md-0">
          <div id="carouselExampleCaptions" className="carousel slide carousel-fade" data-bs-ride="carousel">
            <div className="carousel-inner">
              {/*Segundo Slider - VERSIÓN ORIGINAL CON WEBP (COMENTADA)
              data-bs-interval="100000"

              <div className="carousel-item active slider-two" data-bs-interval={interval}>
                  <img src={isMobileBanner ? bannerProductMobile : bannerProduct} className="d-block w-100 background-slider" fetchPriority="high" alt="background Slider2" />
                  <div className="carousel-caption d-flex flex-column ps-5">
                    <div className='container-fluid'>
                      <div className='row'>
                        <div className='col-lg-5 col-md-4 col-12 d-flex flex-column justify-content-center order-lg-0 order-1'>
                           <h1 className="display-4  lightblack mb-3 text-start tit-principal tit-slider" style={{}}>
                            <span style={{ color: 'var(--color-principal)' }}>Etiquetas para cualquier</span> tipo de industria
                          </h1>
                          <div className="d-flex gap-3 justify-content-start">
                            <a href="/productos" className="btn btn-custom mt-2 mb-sm-0 p-3">
                              Nuestras productos
                            </a>
                          </div>
                        </div>
                        <div className='col-md-7 col-12 order-lg-1 order-0 pb-md-0 pb-5'>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              */}
              {/*Primer Slider - NUEVA VERSIÓN CON ANIMACIONES GSAP*/}
              <AnimatedSlider interval={interval} />
              {/*Segundo Slider*/}
              <div className="carousel-item slider-one"  data-bs-interval="4000">
                <img src={isMobile ? bannerMobile1 : banner1} className="d-block w-100 background-slider" alt="background Slider"/>
                <div className="carousel-caption d-flex flex-column justify-content-center">
                  <AnimacionVasoKaliman/>
                  <h1 className="display-4  lightblack mb-0 tit-principal tit-slider">
                    Etiquetas que <span style={{ color: 'white' }}> <br></br> hacen más</span>
                  </h1>
                  <div className="d-flex gap-1 justify-content-center">
                    <button to="https://wa.link/9qu07v" aria-label="Chatea con nosotros por WhatsApp" rel="noopener noreferrer" target="_blank" className="btn btn-custom mt-4 mb-0 p-3">
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="me-2 bi bi-whatsapp" viewBox="0 0 16 16">
                        <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                      </svg>
                      Contáctanos
                    </button>
                  </div>


                </div>
              </div>
              {/*Tercero Slider data-bs-interval="100000"*/}
              <div className="carousel-item slider-two" data-bs-interval="3000">
                  <img src={isMobile ? bannerMobile2 : banner2} className="d-block w-100 background-slider" alt="background Slider2" />
                  <div className="carousel-caption d-flex flex-column ps-5">
                    <h1 className="display-4  lightblack mb-3 text-start tit-principal tit-slider" style={{width:'65%'}}>
                      Más de dos décadas colaborando con <span style={{ color: 'var(--color-principal)' }}>marcas que exigen resultados</span>
                    </h1>
                    <p className="text-start" style={{color:'var(--color-texr-gris-dark)', width:'55%'}}>Más de 28 años acompañando a empresas de distintos sectores a sobresalir.  Desarrollamos etiquetas y soluciones a tu medida siempre con un extra.</p>
                    <div className="d-flex gap-3 justify-content-start">
                      <a href="/nuestra-esencia" className="btn btn-custom mt-2 mb-sm-5 p-3">
                        Conoce quiénes somos
                      </a>
                    </div>
                  </div>
              </div>
              {/*Cuarto Slider
              data-bs-interval="100000"
              */}
              <div className="carousel-item slider-three"  data-bs-interval="3000">
                <img src={isMobile ? bannerMobile3 : banner3} className="d-block w-100 background-slider" alt="background Slider3"/>
                <div className="carousel-caption d-flex flex-column ps-5">
                  <h1 className="display-4  lightblack mb-3 text-start tit-principal tit-slider" style={{ width:'45%'}}>
                    Nuestras soluciones<span style={{ color: 'white' }}> <br></br> potencializan el éxito de tu producto</span>
                  </h1>
                  <div className="d-flex gap-3 justify-content-start">
                    <a href="/soluciones-industria" className="btn btn-custom mb-sm-5 p-3" style={{background:'var(--color-secundario-blanco)', color:'var(--color-text-negro-light)'}}>
                      Soluciones por industria
                    </a>
                  </div>
                </div>
              </div>
              {/*Quinto Slider
              data-bs-interval="10000000"
              */}
              <div className="carousel-item slider-four"  data-bs-interval="6000">
                <img src={isMobile ? bannerMobile4 : banner4} className="d-block w-100 background-slider" alt="background Slider 4"/>
                  <div className="carousel-caption d-flex flex-column justify-content-center ps-5">
                    <div className='container-fluid'>
                      <div className='row'>
                        <div className='col-md-7 cont-txt-powerpoffgirl d-flex flex-column justify-content-center'>
                          <h1 className="display-4  lightblack mb-3 text-start tit-principal tit-slider" style={{width:'100%'}}>
                          <span style={{ color: 'var(--color-principal)' }}>ISO 22000:</span>  <br></br> Calidad y seguridad que respalda cada etiqueta en tus alimentos.
                          </h1>
                          <p className="text-start" style={{color:'var(--color-texr-gris-dark)'}}>Solo procesos seguros, consistentes y auditables en cada etiqueta.</p>
                          <div className="d-flex gap-3 justify-content-start">
                            <a href="/certificaciones" className="btn btn-custom mt-2 mb-5 p-3">
                              Nuestros certificados
                            </a>
                          </div>
                        </div>
                        <div className='col-sm-5 col-12 cont-img-powerpoffgirl' >
                          <AnimacionVasoLogo/>
                          
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              {/*Sexto Slider*/}
              <div className="carousel-item slider-five"  data-bs-interval="3000">
                <img src={isMobile ? bannerMobile5 : banner5} className="d-block w-100 background-slider" alt="background Slider 5"/>
                <div className="carousel-caption d-flex flex-column ps-5" style={{height: '100%'}}>
                  {/**Slider de logos para Mobile */}
                  {/**NOTA RECUERDA: 
                         * imagenes debe ser un nuevo arreglo especial para mobiles que contenga todas las imagenes 
                         * En caso que haya más logs
                         * */}
                  {/*<div className='d-block d-md-none d-lg-none'>
                    <div className='container-fluid logo-empresas'>
                      <div className='row'>
                        
                        <VerticalSlider images={imgsCol1} reverse={false} height="20%" interval={1500} />
                      </div>
                    </div>
                  </div>*/}
                  <div className='container-fluid'>
                    <div className='row'>
                      {/*<div className='col-md-7 col-12 text-start'>*/}
                        {/*<div className='d-block d-md-none'>
                          <div className='container-fluid'>
                            <div className='gcont-log row'>
                              <div className='col-6 cont1-logo'>
                                <img src={logoAlpura} alt="Alpura"/>
                                <img src={logoChobani} alt="Chobani}"/>
                                <img src={logoDove} alt="Dove"/>
                              </div>
                              <div className='col-6 cont2-logo'>
                                <img src={logoChupachups} alt="Chupachup"/>
                                <img src={logoGourmet} alt="Gourmet"/>
                                <img src={logoRancho} alt="Rancho"/>
                              </div>
                              <div className='col-12 cont3-logo'>
                                <img src={logoTrujillo} alt="Trujillo"/>
                                <img src={logoKrispykreme} alt="Krispykreme"/>
                              </div>
                            </div>
                          </div>
                        </div>*/}
                      {/*</div>*/}
                      {/**Texto */}
                      <div className='col-md-5 col-12 order-md-0 order-1 d-flex flex-column justify-content-center'>
                        <h1 className="display-4  lightblack mb-3 text-start tit-principal tit-slider" style={{ color:'var(--color-principal)'}}>
                          Marcas con las<span style={{ color: 'white'}}> <br/> que crecemos juntos</span>
                        </h1>
                        <div className="d-flex gap-3 justify-content-start">
                          <a href="/historias-exito" className="btn btn-custom mt-2 mb-2 p-3">
                            Nuestras historias de éxito
                          </a>
                        </div>
                      </div>
                     {/**Logo */}
                      <div className='col-md-7 col-12 order-md-1 order-0 text-start'>
                        <div className='d-none d-md-block'>
                          <div className='gcont-log'>
                            <div className='cont1-logo'>
                              <img loading="lazy" src={logoAlpura} alt="Logo Alpura" />
                              <img loading="lazy" src={logoChobani} alt="Logo Chobani" />
                              <img loading="lazy" src={logoDove} alt=" Logo Dove" />
                            </div>
                            <div className='cont2-logo'>
                              <img loading="lazy" src={logoChupachups} alt="Logo Chupachup" />
                              <img loading="lazy" src={logoGourmet} alt="Logo Gourmet"/>
                              <img loading="lazy" src={logoRancho} alt="Logo Rancho"/>
                            </div>
                            <div className='cont3-logo'>
                              <img loading="lazy" src={logoTrujillo} alt="Logo Trujillo"/>
                              <img loading="lazy" src={logoKrispykreme} alt="Logo Krispykreme"/>
                            </div>
                          </div>
                        </div>

                        <div className='d-block d-md-none'>
                          <div className='container-fluid'>
                            <div className='gcont-log row'>
                              <div className='col-6 cont1-logo'>
                                <img loading="lazy" src={logoAlpura} alt="Logo Alpura"/>
                                <img loading="lazy" src={logoChobani} alt="Logo Chobani"/>
                                <img loading="lazy" src={logoDove} alt="Logo Dove"/>
                              </div>
                              <div className='col-6 cont2-logo'>
                                <img loading="lazy" src={logoChupachups} alt="Logo Chupachup"/>
                                <img loading="lazy" src={logoGourmet} alt="Logo Gourmet"/>
                                <img loading="lazy" src={logoRancho} alt="Logo Rancho"/>
                              </div>
                              <div className='col-12 cont3-logo'>
                                <img loading="lazy" src={logoTrujillo} alt="Logo Trujillo"/>
                                <img loading="lazy" src={logoKrispykreme} alt="Logo Krispykreme"/>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  
                  {/*<div className="d-flex flex-row position-absolute gap-lg-5 gap-0 pe-md-0 sliders-logo">
                    <div className='d-none d-md-block'>
                      <div className="d-flex flex-column logo-empresas">
                        <VerticalSlider images={imgsCol1} reverse={false} height="100%" interval={1500} />
                      </div>
                      <div className="d-flex flex-column logo-empresas">
                        <VerticalSlider images={imgsCol2} reverse={true} height="100%" interval={1500} />
                      </div>
                    </div>
                    
                  </div>*/}
                  
                </div>
              </div>
            </div>
            {/* Botones de navegación */}
              <div className="slider-controls position-absolute d-flex flex-column justify-content-center" 
                style={{
                  right: '20px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  zIndex: 4
                }}
              >
                <button 
                  onClick={prevSlide}
                  className="btn btn-slider mb-2"
                  aria-label="Anterior slide"
                  data-bs-target="#carouselExampleCaptions"
                  data-bs-slide="prev"
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--color-principal)',
                    border: 'none',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '18px'
                  }}
                >
                  {/*<i className="fas fa-arrow-left"></i>*/}
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
                  </svg>
                </button>
                <button 
                  onClick={nextSlide}
                  className="btn btn-slider"
                  aria-label="Siguiente slide"
                  data-bs-target="#carouselExampleCaptions"
                  data-bs-slide="next"
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    backgroundColor: 'var(--color-principal)',
                    border: 'none',
                    color: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '18px'
                  }}
                >
                  {/*<i className="fas fa-arrow-right"></i>*/}
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-arrow-right" viewBox="0 0 16 16">
                    <path fillRule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"/>
                  </svg>
                </button>
              </div>
            {/*<button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev">
              <span className="carousel-control-prev-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Previous</span>
            </button>
            <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next">
              <span className="carousel-control-next-icon" aria-hidden="true"></span>
              <span className="visually-hidden">Next</span>
            </button>*/}
          </div>

          {/* First Section */}
          <div className='container-fluid pdg-section-ch'>
            <div className="row align-items-center mb-5">
              <div className="col-lg-7 mb-md-auto mb-5" style={{paddingRight: '5%'}}>
                <h1 className="display-4  lightblack mb-3 tit-principal">
                  <span style={{ color: 'var(--color-principal)' }}>En Mega Label transformamos</span> etiquetas en experiencias
                </h1>
                {/*
                  <p className="lightblack">
                  Con una de las tres máquinas más innovadoras de Latinoamérica, personalizamos en serie lo que otros solo sueñan, con tiempos de entrega que marcan el estándar.
                </p>
                <p className="lightblack">
                  Hacemos que una etiqueta se vuelva un vaso, que tu marca se vuelva inolvidable, y que cada industria encuentre en nosotros soluciones a la medida.
                </p>
                <p className="lightblack py-2">
                  <strong>Calidad certificada, respaldados por tecnología y movidos por la innovación.</strong>
                </p>                
                */}
                <p className="lightblack">
                  Contamos con máquinas que promueven la innovación de diferentes proyectos, personalizando y creando lo que otros solo sueñan.
                </p>
                <p className="lightblack">
                  Marcamos la diferencia con tiempos de entrega mejorados haciendo que cada marca y cada industria encuentre soluciones a su medida.
                </p>
                <p className="lightblack py-2">
                  <strong>Garantizamos: Calidad, Estándares, Innovación y Soluciones.</strong>
                </p>
                <div className="d-flex gap-3 justify-content-start">
                  <a href="/maquinaria" className="btn btn-custom mt-md-5 mt-3 p-md-3 p-4">
                    Ver tecnología en acción
                  </a>
                </div>
              </div>
              <div className="col-lg-5 ps-md-3">
                <img 
                  src={transformamosEtiquetas}
                  alt="Maquinaria de Etiquetado"
                  style={{
                    width: '100%',
                    paddingLeft: '1%'
                  }}
                />
              </div>
            </div>
          </div>

          {/* Productos Section 3 */}
          <div className='container-fluid pdg-section-ch h-sec3' style={{background:'var(--color-text-negro-light)'}}>
            <div className="row align-items-center mb-5">
              <div className="col-lg-12">
                <h1 className="display-4 mb-4 tit-principal">
                  <span style={{ color: 'var(--color-principal)'}}>Sumamos valor a tu producto. </span>Cualquiera que sea tu industria
                </h1>
                <p className="lightblack mb-5" style={{color:'white'}}>
                  Etiquetas que cumplen las exigencias de tu sector y además, destacan.
                </p>
              </div>
              <div className="col-lg-12 opc-producto">
                <div className="row">
                  <div className="col-lg-6 col-md-6 mb-4">
                    <button className="btn btn-industry w-100 h-100 d-flex align-items-center p-4" 
                    onClick={() => history("/soluciones-industria")}
                    aria-label="Ir a servicio Alimentos y Bebidas"
                    style={{
                      width: '100%',
                      border: 'none',
                      borderRadius: '10px',
                      color: 'white',
                      transition: 'all 0.3s ease'
                    }}>
                      <img src={iconoAlimentos} alt="Alimentos"/>
                      <span className="fw-bold button-producto text-start">Alimentos y Bebidas</span>
                    </button>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-4">
                    <button className="btn btn-industry w-100 h-100 d-flex align-items-center p-4" 
                    onClick={() => history("/soluciones-industria")}
                    aria-label="Ir a servicio Industria Farmacéutica Humana y Veterinaria"
                    style={{
                      width: '100%',
                      border: 'none',
                      borderRadius: '10px',
                      color: 'white',
                      transition: 'all 0.3s ease'
                    }}>
                      <img src={iconoFarmaceutica} alt="Farmacéutica"/>
                      <span className="fw-bold button-producto text-start">Industria Farmacéutica Humana y Veterinaria</span>
                    </button>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-4">
                    <button className="btn btn-industry w-100 h-100 d-flex align-items-center p-4" 
                    onClick={() => history("/soluciones-industria")}
                    aria-label="Ir a servicio Cosmética y Belleza"
                    style={{
                      width: '100%',
                      border: 'none',
                      borderRadius: '10px',
                      color: 'white',
                      transition: 'all 0.3s ease'
                    }}>
                      <img src={iconoCosmetica} alt="Cosmética" />
                      <span className="fw-bold button-producto text-start">Cosmética y Belleza</span>
                    </button>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-4">
                    <button className="btn btn-industry w-100 h-100 d-flex align-items-center p-4" 
                      onClick={() => history("/soluciones-industria")}
                    aria-label="Ir a servicio Vinos y Licores"
                    style={{
                      width: '100%',
                      border: 'none',
                      borderRadius: '10px',
                      color: 'white',
                      transition: 'all 0.3s ease'
                    }}>
                      <img src={iconoVinos} alt="Vinos" />
                      <span className="fw-bold button-producto text-start">Vinos y Licores</span>
                    </button>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-4">
                    <button className="btn btn-industry w-100 h-100 d-flex align-items-center p-4" 
                    onClick={() => history("/soluciones-industria")}
                    aria-label="Ir a servicio Industria Animal"
                    style={{
                      width: '100%',
                      border: 'none',
                      borderRadius: '10px',
                      color: 'white',
                      transition: 'all 0.3s ease'
                    }}>
                      <img src={iconoAnimal} alt="Mascota"/>
                      {/*
                      <span className="fw-bold button-producto text-start">Industria Animal</span>
                      
                      */}
                      <span className="fw-bold button-producto text-start">Otras Industrias</span>
                    </button>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-4">
                    <button className="btn btn-industry w-100 h-100 d-flex align-items-center p-4" 
                      onClick={() => history("/soluciones-industria")}
                    aria-label="Ir a servicio Industria Manufactureras"
                    style={{
                      width: '100%',
                      border: 'none',
                      borderRadius: '10px',
                      color: 'white',
                      transition: 'all 0.3s ease'
                    }}>
                      <img src={iconoManufacturera} alt="Manufacturera"/>
                      <span className="fw-bold button-producto text-start">Industria Manufacturera</span>
                    </button>
                  </div>
                  <div className="col-lg-6 col-md-6 mb-4">
                    <button className="btn btn-industry w-100 h-100 d-flex align-items-center p-4" 
                      onClick={() => history("/soluciones-industria")}
                    aria-label="Ir a servicio Industria Manufactureras"
                    style={{
                      width: '100%',
                      border: 'none',
                      borderRadius: '10px',
                      color: 'white',
                      transition: 'all 0.3s ease'
                    }}>
                      <img src={iconoEventosMasivos} alt="Manufacturera"/>
                      <span className="fw-bold button-producto text-start">Eventos Masivos</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/**Video */}
          <div className='container-fluid pdg-section-ch pb-md-0 container-video' style={{background:'linear-gradient(to top,rgb(255, 255, 255) 0%,rgb(255, 255, 255) 55%,var(--color-text-negro-light) 55%,var(--color-text-negro-light) 100%)', paddingTop: '5.5%'}}>
            <h1 className="display-4 mb-5 tit-principal text-center" style={{color:'white', textAlign:'start'}}>
              <span style={{ color: 'var(--color-principal)'}}>Cada etiqueta </span>cuenta una historia
            </h1>
            <div className="video-container">
              <iframe 
                className='video-institucional'
                width='100%'
                height='680px'
                loading="lazy"
                src="https://www.youtube.com/embed/7jKYCc1DPig?si=Y4Xdu_fU2MdK5h-N" 
                title="YouTube video player" 
                style={{borderRadius:'24px 30px'}}
                frameBorder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                referrerPolicy="strict-origin-when-cross-origin" 
                allowFullScreen>
              </iframe>
            </div>
            <img className='esta-es-la-nuestra' src={videoEtiqueta} alt="Etiqueta"/>
            {/*<a href='https://youtu.be/fWa_TYUBg8o' aria-label="Video Institucional" rel="noopener noreferrer" target="_blank" ><img className='w-100' src={video} alt="Video Mega Label"/></a>
            <img className='esta-es-la-nuestra' src={videoEtiqueta} alt="Etiqueta"/>*/}
          </div>
          {/* Experiencias Section */}
          <div className='container-fluid pdg-section-ch pt-0'>
            <div className="row align-items-center">
              <div className="col-lg-5 ps-md-3 order-lg-0 order-1">
                <img 
                  src={experiencia}
                  alt="Nuestra experiencia"
                  className="rounded"
                  style={{
                    width: '100%'
                  }}
                />
              </div>
              <div className="col-lg-7 order-lg-1 order-0 m-md-0 mb-5 ps-lg-5 pb-md-auto pb-5">
                <h1 className="display-4 tit-principal lightblack mb-3 ">
                  <span style={{ color: 'var(--color-principal)'}}>Nuestra experiencia:</span> tu ventaja competitiva
                </h1>
                <p className="lightblack">
                  Cada industria y cada etiqueta han sido parte de la experiencia que plasmamos en cada nuevo proyecto.
                </p>
                <div className="d-flex gap-3">
                  <a href="/nuestra-esencia" className="btn btn-custom mt-5 p-3">
                    Conoce nuestra esencia
                  </a>
                </div>
              </div>
            </div>
          </div>
          {/* Vasos Section */}
          <div className='container-fluid pdg-section pt-md-5 pb-md-0 pb-0'>
            <div className="row align-items-center">
              <div className="col-lg-8 ">
                <h1 className="display-4 tit-principal lightblack mb-3" style={{width:'90%'}}>
                  <span style={{ color: 'var(--color-principal)' }}>Más que clientes, historias reales de éxito </span>que respaldan nuestra calidad y compromiso
                </h1>
                <div className="d-flex gap-3">
                  <a href="/historias-exito" className="btn btn-custom mt-md-5 mt-3 p-md-3 p-4">
                    Historias de Éxito
                  </a>
                </div>
              </div>
              <div className="col-lg-4 ps-md-3 d-flex flex-row sectionvasoshome">
                <img src={vasosFinal} className='d-block w-100' alt="Vaso con etiqueta"/>
                  {/*<img 
                    src={vasosRight}
                    alt="Vaso con etiqueta"
                    className="vaso-right"
                  />
                  <img 
                    src={vasosLeft}
                    alt="Vaso México Metal Fest IV"
                    className="vaso-left"
                  />*/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Inicio; 